import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import type { AppUser } from "@/auth/AuthProvider";

export interface RouterContext {
  /** Current authenticated user — populated in main.tsx via router.context. */
  user: AppUser | null;
}

export const router = createRouter({
  routeTree,
  context: {
    user: null,
  } satisfies RouterContext,
  defaultPreload: "intent",
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
